import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { gql } from 'apollo-boost'
import { makeStyles } from '@material-ui/styles'
import { useMutation } from '@apollo/react-hooks'
import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  colors,
  ListItemIcon,
  MenuItem,
  Divider,
  Typography,
  Link,
} from '@material-ui/core'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'
import getInitials from 'utils/getInitials'
import MemberForm from 'components/Forms/MemberForm'
import GenericMoreButton from 'components/GenericMoreButton'
import { Link as RouterLink } from '@reach/router'

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'visible',
  },
  header: {
    paddingBottom: 0,
  },
  content: {
    paddingTop: 0,
  },
  actions: {
    backgroundColor: colors.grey[50],
  },
  manageButton: {
    width: '100%',
  },
}))

const REMOVE_USER_FROM_DISTRICT = gql`
  mutation ($districtID: ID!, $userID: ID!) {
    removeUserFromDistrict(districtID: $districtID, userID: $userID) {
      message
    }
  }
`

const UPDATE_MEMBERS = gql`
  mutation ($id: ID!, $users: [ID]!) {
    addMembersToDistrict(id: $id, users: $users) {
      message
    }
  }
`

const Members = (props) => {
  const { members, className, addMember, districtID, refetch, ...rest } = props
  const classes = useStyles()
  const [removeUserFromDistrict] = useMutation(REMOVE_USER_FROM_DISTRICT)
  const [addMembersToDistrict] = useMutation(UPDATE_MEMBERS)
  const [openEdit, setOpenEdit] = useState(false)

  const handleEditClose = () => {
    setOpenEdit(false)
    refetch()
  }

  const handleRemove = async (id) => {
    try {
      await removeUserFromDistrict({
        variables: { districtID: districtID, userID: id },
      })
    } catch {}

    refetch()
  }

  const handleMemberSelect = (users) => {
    return addMembersToDistrict({ variables: { id: districtID, users: users } })
  }

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title="Medlemmer" />
      <Divider />
      <CardContent className={classes.content}>
        <List>
          {members.map((member) => (
            <ListItem disableGutters key={member.id}>
              <ListItemAvatar>
                <Avatar alt="Author" className={classes.avatar} src={member.profileImage}>
                  {getInitials(member.fullName)}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Link color="inherit" component={RouterLink} to={`/users/${member.slug}`}>
                    {member.fullName}
                  </Link>
                }
                primaryTypographyProps={{ variant: 'h6' }}
                secondary={`${member.email} - ${member.mobile ? member.mobile : ''}`}
              />
              <GenericMoreButton>
                <MenuItem
                  onClick={() => {
                    handleRemove(member.id)
                  }}
                >
                  <ListItemIcon>
                    <RemoveCircleIcon />
                  </ListItemIcon>
                  <ListItemText primary="Fjern" />
                </MenuItem>
              </GenericMoreButton>
            </ListItem>
          ))}
        </List>
      </CardContent>

      <CardActions className={classes.actions}>
        <div className={classes.manageButton}>
          <Typography>Legg til medlem</Typography>
          <MemberForm
            onSubmitSuccess={handleEditClose}
            handleCancel={handleEditClose}
            currentUsers={members}
            handleUserSelect={handleMemberSelect}
          ></MemberForm>
        </div>
      </CardActions>

      {/* <Dialog
        fullScreen={fullScreen}
        open={openEdit}
        onClose={handleEditClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle disableTypography id="form-dialog-title">
          <Typography variant="h4">Legg til medlem</Typography>
        </DialogTitle>
        <DialogContent dividers>
          <MemberForm
            districtID={districtID}
            onSubmitSuccess={handleEditClose}
            handleCancel={handleEditClose}
          ></MemberForm>
        </DialogContent>
      </Dialog> */}
    </Card>
  )
}

Members.propTypes = {
  className: PropTypes.string,
  members: PropTypes.array.isRequired,
  districtID: PropTypes.string.isRequired,
  refetch: PropTypes.func,
}

export default Members
